import type { TRuleWithTheme } from 'styles/theme';

export const container: TRuleWithTheme = () => ({
    '@media (min-width: 992px)': {
        '& .ant-col-lg-5': {
            display: 'block',
            flex: '0 0 19.83333333%',
            maxwidth: '20.83333333%',
        },
    },
});
export const header: TRuleWithTheme = () => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
});


export const headerTitle: TRuleWithTheme = () => ({
    display: 'flex',
    alignItems: 'center',
});

export const title: TRuleWithTheme = () => ({
    fontSize: '1.5rem',
    '&.ant-typography': {
        fontSize: '1.5rem',
        lineHeight: 1.33,

        margin: 0,
    },
});

export const button: TRuleWithTheme = () => ({
    flexShrink: 0,

    padding: 0,

    marginRight: '1rem',
    ':hover': {
        background: 'none',
    },

    width: '1.5rem',
    height: '1.5rem',

    border: 'none',
    boxShadow: 'none',
    backgroundColor: 'transparent',
});

export const icon: TRuleWithTheme = ({ theme }) => ({
    color: theme.colors.iconActive,
});

export const searchContainer: TRuleWithTheme = ({ theme }) => ({
    marginTop: '2.06rem',
});

export const content: TRuleWithTheme<{
    goBack: boolean;
}> = ({ goBack }) => ({
    marginLeft: goBack ? '2.5rem' : 0,
});
